import React, { useEffect, useState } from "react";
import "./Articles.css";
import currentArticles from "./currentArticles";
import Pagination from "../Pagination";
import { Link } from "react-router-dom";
import CategoryTitle from "../CategoryTitle";
import { useLanguage } from "../LanguageContext";
import { getLocalizedArticle } from "../localizedContent";
import { getFallbackImage, replaceWithFallback } from "../imageFallbacks";

function Articles() {
  const { language, t } = useLanguage();
  const [resultsOnPage] = useState(4);
  const [pageNumber, setPageNumber] = useState(0);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <div className="articles">
      <CategoryTitle category="Artykuły" categoryInfo="" />
      <Pagination
        resultsOnPage={resultsOnPage}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        collection={currentArticles}
        scrollToTopOnChange={false}
      />
      <div className="card-deck aricles-card-deck">
        {currentArticles
          .slice(pageNumber * resultsOnPage, pageNumber * resultsOnPage + resultsOnPage)
          .map((article) => {
            const localizedArticle = getLocalizedArticle(article, language);
            return (
              <div className="card" key={article.id}>
                <img
                  className="card-img-top"
                  src={localizedArticle.image || getFallbackImage("place")}
                  onError={(event) => replaceWithFallback(event, "place")}
                  alt=""
                />
                <div className="card-body">
                  <h5 className="card-title">{localizedArticle.title}</h5>
                  <p className="card-text">{localizedArticle.rawContent.substring(0, 200) + "..."}</p>
                  <Link to={"/artykuly/" + localizedArticle.id} className="frist-articles-button btn btn-primary">
                    {t("readMore")}
                  </Link>
                </div>
              </div>
            );
          })}
      </div>
      <Pagination
        resultsOnPage={resultsOnPage}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        collection={currentArticles}
        scrollToTopOnChange={true}
      />
    </div>
  );
}

export default Articles;
